import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { trim } from "lodash";
import React, { Fragment, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import Loader from "../Components/Global/Loader";
import Navbar from "../Components/Layout/Navbar";
import { useAuth } from "../Context/AuthContext";

import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import useToastify from "../hooks/useToastify";



function Login() {
  const { setToken, setIsAuthenticated, setLoginSuccessmsg, designation } =
    useAuth();
  const [forgetemail, setForgetEmail] = useState({ email: "" });
  const { email } = forgetemail;
  const [loading, setLoading] = useState(false);
  const [loginerror, setLoginError] = useState();
  const [forgeterror, setForgetError] = useState();
  const [forgetShow, setForgetShow] = useState(false);
  const ForgethandleClose = () => setForgetShow(false);
  const ForgethandleShow = () => setForgetShow(true);
const {
  notify
}=useToastify();
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
    password_type: "password",
  });
  const { password_type } = loginData;
  const validation = (values) => {
    const errors = {};
    const onlyText = /^[a-zA-Z0-9' . - _ ! $ % @ & # ? : ; ^ ~,/*-]+$/;

    if (!values.username || !trim(values.username)) {
      errors.username = "Please enter your username.";
    } else if (!onlyText.test(values.username)) {
      errors.username = "Please enter a valid username.";
    }

    if (!values.password || !trim(values.password)) {
      errors.password = "Please enter your password.";
    } else if (!onlyText.test(values.password)) {
      errors.password = "Please enter a valid password.";
    } else if (values.password.length < 8) {
      errors.password = "Please enter at least 8 characters. ";
    }

    return errors;
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setForgetEmail({ ...forgetemail, [e.target.name]: value });
    setForgetError("");
  };

  const SubmitHandler = (value) => {
    setLoginError();
    setLoading(true);
    axios
      .post("login", value)
      .then(function (response) {
        if (response.status === 200) {
          setLoginSuccessmsg(response?.data?.response?.message);
          setToken(response.data.response.token);
          setIsAuthenticated(true);
        }
      
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response.status === 401) {
          setLoginError(error.response.data.message);
        } else {
          setLoginError("Internal Server Error");
        }
      });
  };

  const DataSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post("verify/email", forgetemail)
      .then(function (response) {
        notify(response?.data?.msg, "success");
        if (response.status === 200) {
          ForgethandleClose();
        } else if (response.status === 201) {
          ForgethandleShow();
          setForgetError(response.data.msg);
        }
       
       
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Navbar />
      {loading && <Loader />}
      <div className="dashboard-main d-flex justify-content-center px-xl-5 px-md-3 py-xl-5 py-md-3 overflow-auto w-100">
        <Formik
          initialValues={loginData}
          validate={validation}
          onSubmit={(values, { setSubmitting }) => {
            SubmitHandler(values);
            setSubmitting(false);
          }}
        >
          {({ values, errors, touched }) => (
            <Fragment>
              <div className="login_form custom__form-a">
                <Form className="form-area">
                  <h1 className="mb-xl-5 mb-lg-4 mb-md-3 text-center">Login</h1>
                  <div className="row gy-4">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Username
                      </label>
                      <Field
                        type="text"
                        name="username"
                        value={values.username}
                        className={`form-control frm-gp1 active ${errors.username && touched.username ? "error" : ""
                          }`}
                        placeholder={`Username`}
                      />
                      <ErrorMessage
                        component="div"
                        className="text-m text-red-500 error-message"
                        name="username"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Password
                      </label>
                      <div className="position-relative">
                        <Field
                          type={password_type}
                          name="password"
                          value={values.password}
                          className={`form-control frm-gp1  ${errors.password && touched.password ? "error" : ""
                            }`}
                          placeholder={`Password`}
                        />
                        <div className="position-absolute top-50 start-100 translate-middle pe-5" onClick={() => { setLoginData({ ...loginData, password_type: password_type == "text" ? "password" : "text" }) }}>
                          {password_type == "text" ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                        </div>
                      </div>
                      <ErrorMessage
                        component="div"
                        className="text-m text-red-500 error-message"
                        name="password"
                      />
                    </div>
                    {loginerror ? (
                      <p className="mt-2 text-center text-red-500">
                        {loginerror}
                      </p>
                    ) : null}
                    <div className="my-3">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg login-btn w-100"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
                <div className="form-text d-flex justify-content-between">
                  <div>
                    <Link to="#" className="account-text mb-2">
                      Don't Have An Account?
                    </Link>
                    <Link to="/register" className="account-text2 mb-2 ps-2">
                      Register here
                    </Link>
                  </div>
                  <button
                    onClick={ForgethandleShow}
                    className="account-text2 mb-2"
                  >
                    Forgot Your Password
                  </button>
                </div>
              </div>
            </Fragment>
          )}
        </Formik>
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={forgetShow}
          onHide={ForgethandleClose}
          className="forgot-password"
        >
          {loading && <Loader />}
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <h3>Forgot Password</h3>
                <p> Enter Your Email Address</p>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control frm-gp1 active"
                    value={email}
                    name="email"
                    onChange={(event) => handleInputChange(event)}
                    placeholder="Enter Email Address"
                  />
                </div>
                {forgeterror ? (
                  <p className="text-m text-red-500 error-message pass-incorrect-msg mt-2">
                    {forgeterror}
                  </p>
                ) : null}
                <div className="w-100 mt-3 mt-lg-5">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) => DataSubmit(e)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Login;
